import { render, staticRenderFns } from "./attributesPopover.vue?vue&type=template&id=72a34652&scoped=true"
import script from "./attributesPopover.vue?vue&type=script&lang=js"
export * from "./attributesPopover.vue?vue&type=script&lang=js"
import style0 from "./attributesPopover.vue?vue&type=style&index=0&id=72a34652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a34652",
  null
  
)

export default component.exports